/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Too_Many_SetsInputs */

const en_us2_workout_too_many_sets = /** @type {(inputs: Workout_Too_Many_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This workout has reached the maximum number of sets.`)
};

const pt_br2_workout_too_many_sets = /** @type {(inputs: Workout_Too_Many_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este treino atingiu o número máximo de séries.`)
};

const es_419_workout_too_many_sets = /** @type {(inputs: Workout_Too_Many_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este entrenamiento llegó al número máximo de series.`)
};

const pt_pt2_workout_too_many_sets = /** @type {(inputs: Workout_Too_Many_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este treino atingiu o número máximo de séries.`)
};

const fr_fr2_workout_too_many_sets = /** @type {(inputs: Workout_Too_Many_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette séance a atteint le nombre maximal de séries.`)
};

const de_de2_workout_too_many_sets = /** @type {(inputs: Workout_Too_Many_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Training hat die maximale Anzahl an Sätzen erreicht.`)
};

const it_it2_workout_too_many_sets = /** @type {(inputs: Workout_Too_Many_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo allenamento ha raggiunto il numero massimo di serie.`)
};

/**
* | output |
* | --- |
* | "This workout has reached the maximum number of sets." |
*
* @param {Workout_Too_Many_SetsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_too_many_sets = /** @type {((inputs?: Workout_Too_Many_SetsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Too_Many_SetsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_too_many_sets(inputs)
	if (locale === "es-419") return es_419_workout_too_many_sets(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_too_many_sets(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_too_many_sets(inputs)
	if (locale === "de-DE") return de_de2_workout_too_many_sets(inputs)
	if (locale === "it-IT") return it_it2_workout_too_many_sets(inputs)
	return en_us2_workout_too_many_sets(inputs)
});
export { workout_too_many_sets as "workout.too_many_sets" }